import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { linkToUsersAndTeamSettings } from '../../urls/linkToUsersAndTeamSettings';
import { useTrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import { useUnassignedSeatsBanner } from '../hooks/useUnassignedSeatsBanner';
import { trackClickManagePaidUsers } from '../utils/event-handlers';
import BannerContent from './BannerContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnassignedSeatsBanner = ({
  onClose
}) => {
  const trackUsage = useTrackUsageContext();
  const {
    isFetching,
    unassignedSeatCount
  } = useUnassignedSeatsBanner(onClose);
  return /*#__PURE__*/_jsxs(BannerContent, {
    onClose: onClose,
    children: [isFetching && /*#__PURE__*/_jsx(LoadingSpinner, {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "routing-ui.routingRules.unassignedSeats_jsx",
      elements: {
        Link
      },
      options: {
        unassignedCount: unassignedSeatCount,
        linkProps: {
          external: true,
          onClick: () => trackUsage(trackClickManagePaidUsers('banner')),
          href: linkToUsersAndTeamSettings(true)
        }
      }
    })]
  });
};
UnassignedSeatsBanner.displayName = 'UnassignedSeatsBanner';
export default UnassignedSeatsBanner;